import FormService from './form-service.js';

// Notification autonome (sans dépendance à calendar.js)
function showNotification(type, message) {
    const notification = document.createElement('div');
    notification.className = `alert alert-${type} notification`;
    notification.textContent = message;
    let container = document.querySelector('.notification-container');
    if (!container) {
        container = document.createElement('div');
        container.className = 'notification-container';
        Object.assign(container.style, {
            position : 'fixed',
            top      : '50%',
            left     : '50%',
            transform: 'translate(-50%, -50%)',
            zIndex   : '9999',
        });
        document.body.appendChild(container);
    }
    container.appendChild(notification);
    setTimeout(() => {
        notification.remove();
        if (!container.children.length) container.remove();
    }, 5000);
}

class ParticipantManager {
    constructor(container) {
        this.container = container;
        this.participantCount = 0;
        // La limite par défaut est 30, mais en pratique elle est remplacée par 
        // max_inscriptions_user - 1 dans setupParticipantsManagement() de calendar.js
        this.maxParticipants = 30;
        this.requireTailleCm = false;
        this.bindEvents();
    }

    bindEvents() {
        this.container.addEventListener('click', (e) => {
            if (e.target.classList.contains('add-participant-btn')) {
                this.addParticipant();
            } else if (e.target.classList.contains('remove-participant-btn')) {
                const participantGroup = e.target.closest('.participant-group');
                if (participantGroup) {
                    this.removeParticipant(participantGroup);
                }
            }
        });
    }

    addParticipant() {
        if (this.participantCount >= this.maxParticipants) {
            showNotification('warning', 'Nombre maximum de participants atteint');
            return;
        }

        const participantsList = this.container.querySelector('.participants-list');
        const addParticipantBtn = this.container.querySelector('.add-participant-btn');
        
        const participantHtml = `
            <div class="participant-group card mb-3" data-index="${this.participantCount}">
                <div class="card-header d-flex justify-content-between align-items-center">
                    <h6 class="mb-0">Participant ${this.participantCount + 1}</h6>
                    <button type="button" class="btn-close remove-participant-btn" aria-label="Supprimer"></button>
                </div>
                <div class="card-body">
                    <div class="row g-3">
                        <div class="col-md-6">
                            <label class="form-label">Nom *</label>
                            <input type="text" class="form-control" name="participants[${this.participantCount}][nom]" required>
                            <div class="invalid-feedback">
                                Veuillez saisir le nom
                            </div>
                        </div>
                        <div class="col-md-6">
                            <label class="form-label">Prénom *</label>
                            <input type="text" class="form-control" name="participants[${this.participantCount}][prenom]" required>
                            <div class="invalid-feedback">
                                Veuillez saisir le prénom
                            </div>
                        </div>
                        <div class="col-md-6">
                            <label class="form-label">Email</label>
                            <input type="email" class="form-control" name="participants[${this.participantCount}][email]">
                            <div class="invalid-feedback">
                                Veuillez saisir une adresse email valide
                            </div>
                        </div>
                        <div class="col-md-6">
                            <label class="form-label">Téléphone</label>
                            <input type="tel" class="form-control" name="participants[${this.participantCount}][telephone]">
                            <div class="invalid-feedback">
                                Veuillez saisir un numéro de téléphone valide
                            </div>
                        </div>
                        ${this.requireTailleCm ? `
                        <div class="col-md-6">
                            <label class="form-label">Taille (cm)</label>
                            <input type="number" class="form-control" name="participants[${this.participantCount}][taille_cm]" min="50" max="250" placeholder="ex\u00a0: 175">
                        </div>` : ''}
                    </div>
                </div>
            </div>
        `;

        participantsList.insertAdjacentHTML('beforeend', participantHtml);
        this.participantCount++;

        if (this.participantCount >= this.maxParticipants) {
            addParticipantBtn.style.display = 'none';
        }
    }

    removeParticipant(participantGroup) {
        participantGroup.remove();
        this.participantCount--;
        
        const addParticipantBtn = this.container.querySelector('.add-participant-btn');
        addParticipantBtn.style.display = 'block';

        // Réorganiser les numéros des participants
        const groups = this.container.querySelectorAll('.participant-group');
        groups.forEach((group, index) => {
            // Mettre à jour le titre du participant
            const titleElement = group.querySelector('.card-header h6');
            if (titleElement) {
                titleElement.textContent = `Participant ${index + 1}`;
            }
            
            group.dataset.index = index;
            
            // Mettre à jour les noms des champs
            group.querySelectorAll('input').forEach(input => {
                const fieldName = input.name.replace(/\[\d+\]/, `[${index}]`);
                input.name = fieldName;
                input.id = fieldName;
                
                // Mettre à jour le label associé si nécessaire
                const label = input.closest('.col-md-6, .col-12')?.querySelector('label');
                if (label) {
                    label.setAttribute('for', fieldName);
                }
            });
        });
    }

    validateAll() {
        const participants = [];
        const groups = this.container.querySelectorAll('.participant-group');
        
        groups.forEach(group => {
            const participant = {
                nom: group.querySelector('[name$="[nom]"]').value,
                prenom: group.querySelector('[name$="[prenom]"]').value,
                email: group.querySelector('[name$="[email]"]').value,
                telephone: group.querySelector('[name$="[telephone]"]').value,
                taille_cm: group.querySelector('[name$="[taille_cm]"]')?.value || ''
            };
            
            if (this.validateParticipant(participant)) {
                participants.push(participant);
            }
        });

        return participants;
    }

    validateParticipant(participant) {
        console.log('Validation du participant:', participant);
        
        // Vérifier uniquement les champs obligatoires (nom et prénom)
        if (!participant.nom || !participant.prenom) {
            console.log('Champs obligatoires manquants:', {
                nom: !participant.nom,
                prenom: !participant.prenom
            });
            showNotification('error', 'Veuillez remplir les champs nom et prénom');
            return false;
        }

        // Vérifier l'email uniquement s'il est rempli
        if (participant.email) {
            const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
            if (!emailRegex.test(participant.email)) {
                console.log('Email invalide:', participant.email);
                showNotification('error', 'Veuillez entrer une adresse email valide');
                return false;
            }
        }

        // Vérifier le téléphone uniquement s'il est rempli
        if (participant.telephone) {
            const phoneRegex = /^0[1-9]\d{8}$/;
            if (!phoneRegex.test(participant.telephone)) {
                console.log('Téléphone invalide:', participant.telephone);
                showNotification('error', 'Le numéro de téléphone doit contenir exactement 10 chiffres et commencer par 0');
                return false;
            }
        }

        console.log('Participant valide');
        return true;
    }

    setRequireTailleCm(required) {
        this.requireTailleCm = !!required;
    }

    setMaxParticipants(max) {
        this.maxParticipants = max;
        const addParticipantBtn = this.container.querySelector('.add-participant-btn');
        const participantsList = this.container.querySelector('.participants-list');
        
        // Gérer le cas spécifique où max_inscriptions_user est 1
        if (max === 0) {
            // max=0 signifie que max_inscriptions_user=1, donc aucun participant supplémentaire autorisé
            addParticipantBtn.style.display = 'none';
            
            // Afficher un message explicatif
            if (participantsList) {
                // Vérifier si le message existe déjà
                let infoMessage = this.container.querySelector('.max-participants-info');
                if (!infoMessage) {
                    infoMessage = document.createElement('div');
                    infoMessage.className = 'max-participants-info alert alert-info mt-2 mb-3';
                    infoMessage.textContent = 'Une seule inscription autorisée pour cette session.';
                    participantsList.parentNode.insertBefore(infoMessage, participantsList);
                }
            }
        } else {
            // Pour les autres cas, comportement standard
            if (this.participantCount >= max) {
                addParticipantBtn.style.display = 'none';
            } else {
                addParticipantBtn.style.display = 'block';
            }
            
            // Supprimer le message s'il existe
            const infoMessage = this.container.querySelector('.max-participants-info');
            if (infoMessage) {
                infoMessage.remove();
            }
        }
    }

    resetParticipants() {
        // Supprimer tous les groupes de participants
        const groups = this.container.querySelectorAll('.participant-group');
        groups.forEach(group => {
            group.remove();
        });
        
        // Réinitialiser le compteur
        this.participantCount = 0;
        
        // Supprimer le message d'information sur la limitation d'inscription
        const infoMessage = this.container.querySelector('.max-participants-info');
        if (infoMessage) {
            infoMessage.remove();
        }
        
        // S'assurer que le bouton d'ajout est visible
        const addParticipantBtn = this.container.querySelector('.add-participant-btn');
        if (addParticipantBtn) {
            // Ne pas afficher automatiquement le bouton, car setMaxParticipants sera appelé
            // après resetParticipants et déterminera si le bouton doit être affiché ou non
        }
    }

    async handleSubmit(form) {
        // Prévention double-soumission
        if (this._isSubmitting) {
            return false;
        }
        this._isSubmitting = true;

        console.log('Début de la soumission du formulaire');
        console.log('Formulaire:', form);
        
        // Valider le participant principal
        const mainParticipant = {
            nom: form.querySelector('[name="nom"]').value,
            prenom: form.querySelector('[name="prenom"]').value,
            email: form.querySelector('[name="email"]').value,
            telephone: form.querySelector('[name="telephone"]').value
        };
        
        console.log('Données du participant principal:', mainParticipant);
        console.log('Champs trouvés:', {
            nom: form.querySelector('[name="nom"]'),
            prenom: form.querySelector('[name="prenom"]'),
            email: form.querySelector('[name="email"]'),
            telephone: form.querySelector('[name="telephone"]')
        });
        
        const isMainParticipantValid = this.validateParticipant(mainParticipant);
        console.log('Validation du participant principal:', isMainParticipantValid);
        
        // Valider les participants supplémentaires
        const additionalParticipants = this.validateAll();
        console.log('Participants supplémentaires:', additionalParticipants);
        
        // Si le participant principal n'est pas valide, stopper la soumission
        if (!isMainParticipantValid) {
            console.error('Le participant principal n\'est pas valide');
            return false;
        }
        
        // Si aucun participant supplémentaire, c'est normal si seul le principal est fourni
        if (this.participantCount > 0 && !additionalParticipants.length) {
            console.error('Participants supplémentaires non valides');
            return false;
        }

        try {
            // Préparer les données du formulaire
            const formData = new FormData(form);
            
            // Ajouter les participants supplémentaires validés
            additionalParticipants.forEach((participant, index) => {
                formData.append(`participants[${index}][nom]`, participant.nom);
                formData.append(`participants[${index}][prenom]`, participant.prenom);
                formData.append(`participants[${index}][email]`, participant.email);
                formData.append(`participants[${index}][telephone]`, participant.telephone);
                if (participant.taille_cm) {
                    formData.append(`participants[${index}][taille_cm]`, participant.taille_cm);
                }
            });

            // Soumettre le formulaire via FormService
            const success = await FormService.submitInscription(formData, form.dataset.eventId);
            
            if (success) {
                console.log('Inscription réussie');
                // Fermer la modale
                const modal = form.closest('.go-booking-modal');
                if (modal) {
                    modal.remove();
                }
                return true;
            } else {
                console.error('Échec de l\'inscription');
                return false;
            }
        } catch (error) {
            console.error('Erreur lors de la soumission:', error);
            showNotification('error', 'Une erreur est survenue lors de la soumission du formulaire');
            return false;
        } finally {
            this._isSubmitting = false;
        }
    }
}

export default ParticipantManager; 